export enum TrailTimeRange {
  ONE_HOUR = 1,
  TWO_HOURS = 2,
  FOUR_HOURS = 4,
  EIGHT_HOURS = 8,
  TWELVE_HOURS = 12,
  TWENTYFOUR_HOURS = 24,
}

export interface TrailOption {
  id: TrailTimeRange;
  label: string;
  value: TrailTimeRange;
  maxHours: number;
}

export const TRAIL_OPTIONS: TrailOption[] = [
  {
    id: TrailTimeRange.ONE_HOUR,
    label: '1 hour',
    value: TrailTimeRange.ONE_HOUR,
    maxHours: 1,
  },
  {
    id: TrailTimeRange.TWO_HOURS,
    label: '2 hours',
    value: TrailTimeRange.TWO_HOURS,
    maxHours: 2,
  },
  {
    id: TrailTimeRange.FOUR_HOURS,
    label: '4 hours',
    value: TrailTimeRange.FOUR_HOURS,
    maxHours: 4,
  },
  {
    id: TrailTimeRange.EIGHT_HOURS,
    label: '8 hours',
    value: TrailTimeRange.EIGHT_HOURS,
    maxHours: 8,
  },
  {
    id: TrailTimeRange.TWELVE_HOURS,
    label: '12 hours',
    value: TrailTimeRange.TWELVE_HOURS,
    maxHours: 12,
  },
  {
    id: TrailTimeRange.TWENTYFOUR_HOURS,
    label: '24 hours',
    value: TrailTimeRange.TWENTYFOUR_HOURS,
    maxHours: 24,
  },
];

export function filterTrailByTimeRange(
  trail: { lat: number; lng: number; timestamp: number }[],
  timeRange: TrailTimeRange
): { lat: number; lng: number; timestamp: number }[] {
  const option = TRAIL_OPTIONS.find((opt) => opt.id === timeRange);
  if (!option || !trail.length) return [];

  const now = Date.now();
  const maxMilliseconds = option.maxHours * 60 * 60 * 1000;

  return trail.filter((point) => {
    const age = now - point.timestamp;
    return age <= maxMilliseconds;
  });
}
